import { PessoaTipo } from "core/features/pessoas/typings";
import { TipoContatoEnum } from "core/features/auth/typings/user";
import { PaginateQuery } from "core/resources/types/shared";
import { TipoSexo } from "core/resources/types/pessoa";

export interface FiltroUnidadeComPessoas extends PaginateQuery {
  pessoaAtivo?: 1 | 0;
}
export interface UnidadeResponse {
  id: string;
  area: number;
  fracao: number;
  numero: string;
  areaConstruida: string;
  peso: number;
  pessoa: PessoaDto | null;
  endereco?: EnderecoDto | null;
  blocoQuadraId: string;
  blocoQuadra: { id: string; nome: string } | null;
  ajuizada?: boolean;
  gruposUnidades?: {
    id: string;
    nome: string;
  }[];
}

export interface UnidadesDashboard {
  totalMoradores: number;
  totalUnidades: number;
  unidadesInadimplentes: number;
  unidadesAdimplentes: number;
}

export interface ParametrosUnidades {
  tipoVisualizacaoPagadorCobrancaId: string;
  categoriasDistribuicao: string;
  receberCobranca: boolean;
}

export interface ParametrosUnidadesForm
  extends Omit<ParametrosUnidades, "receberCobranca"> {
  receberCobranca: "s" | "n";
}

export interface UnidadePaginateResponse {
  id: string;
  area: number;
  numero: string;
  inadimplencia?: boolean;
  juridico?: boolean;
  ajuizada?: boolean;
  acordoParceladoEmAberto?: boolean;
  unificada?: boolean;
  pessoa: {
    id: string;
    nome: string;
    documento: string;
    imagemUrl: string;
    email: string;
    celular?: string | null;
  } | null;
  blocoQuadra: { id: string; nome: string } | null;
}

export interface UnidadesPaginateQuery extends PaginateQuery {
  tenantId?: string;
  blocoQuadraId?: string;
  search?: string;
  gruposUnidadesIds?: string[];
  responsavelId?: string;
}
export interface UnidadeSimplesPaginateResponse {
  id: string;
  numero: string;
  blocoQuadra: { id: string; nome: string } | null;
  responsavel?: string;
  gruposUnidade?: {
    id: string;
    nome: string;
  }[];
}
export interface UnidadeSubtenantsPaginateResponse
  extends UnidadeSimplesPaginateResponse {
  tenant: {
    id: string;
    nome: string;
  };
}

export interface UnidadeForm extends UnidadeResponse {
  gruposUnidadesId?: string[];
}

export enum TipoUnidadePessoaEnum {
  Proprietario = "D66FB0CF-727B-4E20-8B1E-035595719DEF",
  CoProprietario = "D66FB0CF-727B-4E20-8B1E-035595718DEF",
  Socio = "D66FB0CF-727B-4E20-8B1E-035595716DEF",
  Locatario = "D66FB0CF-727B-4E20-8B1E-035595717DEF",
  Outros = "D66FB0CF-727B-4E20-8B1E-035595715DEF",
}

export interface PessoaDto {
  id: string;
  email: string;
  nome: string;
  sexo: string | null;
  imagemUrl: string;
  documento: string;
  dataNascimento: string;
  pis: string;
  rg: string;
  pessoaVinculadaId?: string;
  profissaoId: string;
  tipoVinculoPessoaId: string;
  podeAutorizarPortaria: boolean;
  podeReceberCobranca: boolean;
  moradorExistente: "s" | "n" | null;
  pessoaId: boolean;

  trocarProprietario?: boolean;
  limitarAcessoModulo?: boolean;
  moraForaCondominio?: boolean;
  dataFimAcesso?: string;

  proprietario: boolean;
  locatario: boolean;
  endereco?: EnderecoDto | null;
  tipoUnidadePessoaId?: TipoUnidadePessoaEnum | null;
  observacao?: string;
  contratoFile?: File | null;
  documentoFile?: File | null;

  votante?: boolean;

  permissoes: string[];

  contatos: PessoaContato[];

  enviarEmailAcesso?: boolean;
}

export interface UnidadeDashboardPessoaMorador {
  id: string;
  rg?: string;
  sexo?: TipoSexo | null;
  nome: string;
  profissao?: string;
  dataNascimento?: string;
  documento: string;
  email: string;
  observacao?: string;
  dataFimAcesso?: string | null;
  tipoVinculoPessoa?: string;
  pessoaVinculada?: string;
  contatos: PessoaContato[];
  tipoUnidadePessoa?: string;
  nomeFantasia?: string;
  inscricaoEstadual?: string;
  inscricaoMunicipal?: string;
  isJuridico?: boolean;
  razaoSocial?: string;
}

export interface PessoaContato {
  id: string;
  tipoContatoId: TipoContatoEnum;
  conteudo: string;
  receberCobranca: boolean;
}

export interface UnidadePessoaPaginateResponse {
  id: string;
  usuarioId: string;
  nome: string;
  imagemUrl: string;
  pessoaTipo: PessoaTipo;
  tipoVinculoPessoa: string;
  dataFimAcesso: string;
  tipoUnidadePessoaId: TipoUnidadePessoaEnum;
  ativo: boolean;
}

export interface UnidadeComPessoaResponse {
  unidadeId: string;
  pessoaId: string;
  blocoQuadra: string | null;
  numero: string;
  nomePessoa: string;
  celular: string;
}

export interface EnderecoDto {
  id?: string;
  estadoId: string;
  cidadeId: string;
  bairro: string;
  logradouro: string;
  complemento: string;
  cep: string;
  numero: string;
  observacao: string;
  latitude?: number;
  longitude?: number;
  cidade?: string;
  estado?: string;
}

export interface UnidadeImportacao {
  abatimento: string | undefined;
  area: number;
  area_construida: number;
  bloco: string;
  fracao: number;
  peso: number;
  inquilino_numero: string | undefined;
  inquilino_bairro: string | undefined;
  inquilino_celular: string | undefined;
  inquilino_cep: string | undefined;
  inquilino_cidade: string | undefined;
  inquilino_complemento: string | undefined;
  "inquilino_cpf/cnpj": string | undefined;
  inquilino_email: string | undefined;
  inquilino_endereco: string | undefined;
  inquilino_estado: string | undefined;
  inquilino_forma_de_entrega: string | undefined;
  inquilino_nome: string | undefined;
  inquilino_rg: string | undefined;
  inquilino_telefone: string | undefined;
  proprietario_numero: string | undefined;
  proprietario_bairro: string | undefined;
  proprietario_celular: string | undefined;
  proprietario_cep: string | undefined;
  proprietario_cidade: string | undefined;
  proprietario_complemento: string | undefined;
  "proprietario_cpf/cnpj": string | undefined;
  proprietario_email: string | undefined;
  proprietario_endereco: string | undefined;
  proprietario_estado: string | undefined;
  proprietario_forma_de_entrega: string | undefined;
  proprietario_nome: string | undefined;
  proprietario_rg: string | undefined;
  proprietario_telefone: string | undefined;
  unidade: string | undefined;
}

export interface UnidadeHistoricoPessoaLog {
  data: string;
  title: string;
  message: string;
}

export enum UnidadePessoaEventEnum {
  Criada = "unidadePessoa.criada",
  Excluida = "unidadePessoa.excluida",
  Atualizada = "unidadePessoa.atualizada",
}

export interface UnidadePessoaHistorico {
  id: string;
  pessoaId: string;
  imagemUrl: string | null;
  nome: string;
  pessoaTipo: PessoaTipo;
  tipoUnidadePessoa: {
    id: string;
    nome: string;
  };
  createdAt: string;
  deletedAt: string;
}
